import { IFilteredParamsReducer } from './reducers';

export const getFilteredData = (state: any): IFilteredParamsReducer => state.filteredData;
